/* War Within theme */
/* on-screen diagnostics: add ?debug=1 to the address to see what the crucifix is doing */
window.WWDIAG={lines:[],add(t){this.lines.push(t);const b=document.getElementById('wwdiag');if(b)b.textContent=this.lines.join('\n');console.log('[WW] '+t)}};
if(location.search.indexOf('debug')>-1){
  const b=document.createElement('pre'); b.id='wwdiag';
  b.style.cssText='position:fixed;left:10px;bottom:10px;z-index:99;color:#9fe;background:rgba(0,0,0,.8);font:11px/1.5 monospace;padding:10px;max-width:90vw;white-space:pre-wrap;margin:0';
  document.addEventListener('DOMContentLoaded',()=>document.body.appendChild(b));
  setTimeout(()=>{ if(!document.getElementById('wwdiag')) document.body.appendChild(b); },0);
}


/* the product photo drifts as the page scrolls */
(function(){
  const stage=document.getElementById('gal'), collage=document.querySelector('.collage');
  if(!stage) return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let tick=false;
  const place=()=>{
    const r=stage.getBoundingClientRect();
    const p=(r.top+r.height/2-innerHeight/2)/innerHeight; // -1 above, +1 below
    const k=Math.max(-1.2,Math.min(1.2,p));
    stage.style.transform='translate3d(0,'+(k*-26).toFixed(2)+'px,0) scale('+(1+Math.abs(k)*.012).toFixed(4)+')';
    if(collage) collage.style.transform='translate3d(0,'+(k*16).toFixed(2)+'px,0)';
    tick=false;
  };
  addEventListener('scroll',()=>{if(!tick){tick=true;requestAnimationFrame(place)}},{passive:true});
  addEventListener('resize',place); place();
})();
(function(){
  /* gallery */
  const imgs=[...document.querySelectorAll('#gal img')], btns=[...document.querySelectorAll('#thumbs button')]; let k=0;
  if(imgs.length>1){
    const show=n=>{k=(n+imgs.length)%imgs.length;imgs.forEach((im,i)=>im.classList.toggle('on',i===k));btns.forEach((b,i)=>b.setAttribute('aria-current',i===k))};
    btns.forEach((b,i)=>b.addEventListener('click',()=>show(i)));
    const g=document.getElementById('gal');
    g.addEventListener('click',e=>{const r=g.getBoundingClientRect();show(k+(e.clientX-r.left<r.width/3?-1:1))});
    let sx=null;g.addEventListener('touchstart',e=>sx=e.touches[0].clientX,{passive:true});
    g.addEventListener('touchend',e=>{if(sx==null)return;const dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40)show(k+(dx<0?1:-1));sx=null});
    const shopSec=document.getElementById('ii');addEventListener('keydown',e=>{const d=document.getElementById('notify');if(d&&d.open)return;if(shopSec){const r=shopSec.getBoundingClientRect();if(r.bottom<innerHeight*.3||r.top>innerHeight*.7)return}if(e.key==='ArrowRight')show(k+1);if(e.key==='ArrowLeft')show(k-1)});
  }
  /* wallets: Apple Pay only on Apple devices (keeps PayPal off the page), Shop Pay always when available */
  (function(){
    const auto=document.getElementById('autoWallet'), shopPay=document.getElementById('shopPayBtn');
    let apple=false;
    try{ apple=!!(window.ApplePaySession && ApplePaySession.canMakePayments && ApplePaySession.canMakePayments()); }catch(e){}
    if(auto && apple) auto.hidden=false;
    if(shopPay){
      setTimeout(()=>{
        const up=customElements.get && customElements.get('shop-pay-button');
        if(!up || shopPay.offsetHeight<10){
          shopPay.remove();
          if(auto && auto.hidden) auto.hidden=false;   // nothing else to offer, so show Shopify's own button
        }
      },2500);
    }
  })();

  /* checkout window */
  const panel=document.getElementById('buyPanel'), buy=document.getElementById('acq');
  if(panel&&buy&&!buy.hasAttribute('data-notify')){
    buy.addEventListener('click',()=>panel.showModal());
    document.getElementById('buyX').addEventListener('click',()=>panel.close());
    panel.addEventListener('click',e=>{if(e.target===panel)panel.close()});
  }

  /* the offer appears once the product is on screen, and stays gone once dismissed */
  (function(){
    const offer=document.getElementById('offer'), sec=document.getElementById('ii');
    if(!offer||!sec) return;
    let dismissed=false;
    try{ dismissed=localStorage.getItem('ww-offer')==='off' }catch(e){}
    if(dismissed) return;
    const hide=()=>{ offer.classList.remove('in'); setTimeout(()=>offer.hidden=true,600); try{localStorage.setItem('ww-offer','off')}catch(e){} };
    document.getElementById('offerX').addEventListener('click',hide);
    offer.querySelector('.offer-go').addEventListener('click',hide);
    let shown=false;
    new IntersectionObserver(es=>{
      if(!shown && es[0].isIntersecting && es[0].intersectionRatio>0.5){
        shown=true;
        setTimeout(()=>{ offer.hidden=false; requestAnimationFrame(()=>offer.classList.add('in')) },900);
      }
    },{threshold:[0,.5,1]}).observe(sec);
  })();

  /* copy the discount code */
  const codeBtn=document.getElementById('codeCopy');
  if(codeBtn){
    codeBtn.addEventListener('click',()=>{
      const code=codeBtn.dataset.code||codeBtn.textContent.trim();
      const done=()=>{const t=codeBtn.textContent;codeBtn.textContent='Copied';setTimeout(()=>codeBtn.textContent=t,1600)};
      if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(code).then(done).catch(done)}
      else{const ta=document.createElement('textarea');ta.value=code;document.body.appendChild(ta);ta.select();try{document.execCommand('copy')}catch(e){}ta.remove();done()}
    });
  }

  /* notify dialog */
  const dlg=document.getElementById('notify');
  if(dlg){
    document.querySelectorAll('[data-notify]').forEach(b=>b.addEventListener('click',()=>{dlg.classList.remove('sent');dlg.showModal()}));
    document.getElementById('notifyX').addEventListener('click',()=>dlg.close());
    dlg.addEventListener('click',e=>{if(e.target===dlg)dlg.close()});
    const q=new URLSearchParams(location.search);
    if(q.get('customer_posted')==='true'){dlg.classList.add('sent');dlg.showModal();setTimeout(()=>dlg.open&&dlg.close(),2600);history.replaceState(null,'',location.pathname+'#ii')}
    else if(dlg.querySelector('.err')){dlg.showModal()}
  }
})();



/* No WebGL? Draw the same point cloud with plain 2D canvas so it still moves. */
function boot2D(canvas, fb, crossSrc, depthSrc){
  WWDIAG.add('starting 2D fallback');
  const ctx = canvas.getContext('2d');
  if(!ctx){ WWDIAG.add('2D context refused'); return false }
  const sec = document.getElementById('i');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const load=(src,cors)=>new Promise((r,j)=>{const im=new Image();if(cors)im.crossOrigin='anonymous';im.onload=()=>r(im);im.onerror=()=>j(new Error('image failed'));im.src=src});
  const pair=()=>load(crossSrc,true).then(a=>load(depthSrc,true).then(b=>[a,b]))
      .catch(()=>load(crossSrc,false).then(a=>load(depthSrc,false).then(b=>[a,b])));
  pair().then(([ci,di])=>{
    const W=ci.width,H=ci.height;
    const read=im=>{const c=document.createElement('canvas');c.width=W;c.height=H;const x=c.getContext('2d');x.drawImage(im,0,0,W,H);return x.getImageData(0,0,W,H).data};
    let col,dep;
    try{ col=read(ci); dep=read(di); }catch(e){ WWDIAG.add('2D cannot read pixels'); fb.classList.remove('gone'); return }
    const CAP = 14000;
    let bright=0;
    for(let y=0;y<H;y+=4)for(let x=0;x<W;x+=4){const i=(y*W+x)*4;if((.3*col[i]+.59*col[i+1]+.11*col[i+2])/255>=.07)bright++}
    const density=(bright*16)/(W*H)||.25;
    const step=Math.max(1,Math.round(Math.sqrt((W*H*density)/CAP)));
    const P=[];
    for(let y=0;y<H;y+=step)for(let x=0;x<W;x+=step){
      const i=(y*W+x)*4, r=col[i], g=col[i+1], b=col[i+2];
      const lum=(.3*r+.59*g+.11*b)/255;
      if(lum<.07) continue;
      P.push({x:x-W/2, y:-(y-H/2), z:(dep[i]/255)*140-60, c:'rgba('+Math.min(255,r*1.25|0)+','+Math.min(255,g*1.2|0)+','+Math.min(255,b*1.35|0)+','+(0.3+lum*0.7).toFixed(2)+')', s:lum});
    }
    WWDIAG.add('2D points='+P.length+' step='+step);
    fb.classList.add('gone');
    let mx=0, my=0, spin=0, drag=0, vel=0, down=false, lx=0;
    const isTouch=matchMedia('(hover: none) and (pointer: coarse)').matches;
    canvas.addEventListener('pointermove',e=>{
      const r=canvas.getBoundingClientRect();
      mx=(e.clientX-r.left)/r.width*2-1; my=-((e.clientY-r.top)/r.height*2-1);
      if(down){ vel+=(e.clientX-lx)/innerWidth*1.6; lx=e.clientX }
    });
    canvas.addEventListener('pointerdown',e=>{down=true;lx=e.clientX;vel=0});
    addEventListener('pointerup',()=>down=false);
    let scrollT=0, tick=false;
    addEventListener('scroll',()=>{ if(tick)return; tick=true; requestAnimationFrame(()=>{ scrollT=Math.max(0,Math.min(1,scrollY/Math.max(1,innerHeight))); tick=false }) },{passive:true});
    let visible=true;
    new IntersectionObserver(es=>{visible=es[0].isIntersecting}).observe(sec);
    let cur=0, curY=0;
    function frame(){
      requestAnimationFrame(frame);
      if(!visible || document.hidden) return;
      const dpr=Math.min(devicePixelRatio||1, 1.5);
      const w=sec.clientWidth, h=sec.clientHeight;
      if(canvas.width!==w*dpr||canvas.height!==h*dpr){canvas.width=w*dpr;canvas.height=h*dpr}
      drag+=vel; drag=Math.max(-1.3,Math.min(1.3,drag));
      if(!down){vel*=.92; drag*=.985} else {vel*=.5}
      const a=scrollT*6.2832, eased=a-0.35*Math.sin(2*a);
      const target=mx*(isTouch?.55:1.25)+drag+(isTouch?eased:0);
      const ez=isTouch?.07:.12;
      cur+=(target-cur)*ez; curY+=((-my*(isTouch?.22:.4))-curY)*ez;
      const sin=Math.sin(cur), cos=Math.cos(cur), sinX=Math.sin(curY), cosX=Math.cos(curY);
      const scale=Math.min((h*dpr*.74)/H,(w*dpr*.86)/W);
      const cx=w*dpr/2, cy=h*dpr/2+h*dpr*.12;
      ctx.clearRect(0,0,canvas.width,canvas.height);
      ctx.globalCompositeOperation='lighter';
      const size=Math.max(1,scale*step*.9);
      for(let i=0;i<P.length;i++){
        const p=P[i];
        const zx=p.x*cos+p.z*sin;
        const y1=p.y*cosX - (p.z*cos-p.x*sin)*sinX;
        const sx=cx+zx*scale, sy=cy-y1*scale;
        ctx.fillStyle=p.c;
        ctx.fillRect(sx,sy,size,size);
      }
      ctx.globalCompositeOperation='source-over';
    }
    if(reduce){ requestAnimationFrame(()=>{ frame() }) } else { requestAnimationFrame(frame) }
  }).catch(()=>{ WWDIAG.add('2D image load failed'); fb.classList.remove('gone') });
  return true;
}

function bootCrucifix(){
  const fb=document.getElementById('fallback');
  const canvas=document.getElementById('stage'), sec=document.getElementById('i');
  if(!canvas) return;
  const srcCross=canvas.dataset ? canvas.dataset.cross : null, srcDepth=canvas.dataset ? canvas.dataset.depth : null;
  let triedSoft=false;
  const fail=(why)=>{
    WWDIAG.add('no 3D: '+(why||'unknown'));
    const cs=srcCross||CROSS_SRC, ds=srcDepth||DEPTH_SRC;
    if(!triedSoft && cs && ds){ triedSoft=true; canvas.style.display=''; if(boot2D(canvas,fb,cs,ds)) return }
    if(fb){fb.classList.remove('gone')} canvas.style.display='none';
  };
  WWDIAG.add('boot; THREE='+(typeof window.THREE));
  if(!window.THREE){fail('three.js did not load');return}
  try{ const t=document.createElement('canvas'); WWDIAG.add('webgl='+!!(t.getContext('webgl2')||t.getContext('webgl'))); }catch(e){ WWDIAG.add('webgl test threw'); }
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  let renderer;
  try{ renderer=new THREE.WebGLRenderer({canvas,antialias:false,alpha:true,failIfMajorPerformanceCaveat:false}); }
  catch(e){ fail('WebGL renderer threw: '+e.message); return }
  if(!renderer||!renderer.getContext()){ fail('no WebGL context'); return }
  canvas.addEventListener('webglcontextlost',()=>fail('WebGL context lost'));
  const lowEnd=innerWidth<700||(navigator.deviceMemory&&navigator.deviceMemory<=4)||(navigator.hardwareConcurrency&&navigator.hardwareConcurrency<=4);
  renderer.setPixelRatio(Math.min(devicePixelRatio,lowEnd?1.5:2));
  const scene=new THREE.Scene();
  const camera=new THREE.PerspectiveCamera(35,1,1,5000);
  camera.position.z=1000;
  const group=new THREE.Group(); scene.add(group);

  const load=(src,cors)=>new Promise((r,j)=>{const im=new Image();if(cors)im.crossOrigin='anonymous';im.onload=()=>r(im);im.onerror=()=>j(new Error('image failed: '+src));im.src=src});
  const loadPair=(a,b)=>load(a,true).then(x=>load(b,true).then(y=>[x,y]))
      .catch(()=>{ WWDIAG.add('retrying images without CORS'); return load(a,false).then(x=>load(b,false).then(y=>[x,y])) });
  loadPair(canvas.dataset.cross,canvas.dataset.depth).then(([ci,di])=>{
    const W=ci.width,H=ci.height;
    const px=(im)=>{const c=document.createElement('canvas');c.width=W;c.height=H;const x=c.getContext('2d');x.drawImage(im,0,0,W,H);return x.getImageData(0,0,W,H).data};
    let col,dep; try{col=px(ci);dep=px(di)}catch(err){fail('cannot read image pixels ('+err.name+')');return}
    const pos=[],cols=[],rnd=[];
    // Adaptive sampling: aim for a point count every machine can hold.
    // Too many points is what makes a desktop GPU drop the canvas entirely.
    const TARGET=lowEnd?55000:95000;
    let bright=0;
    for(let y=0;y<H;y+=4)for(let x=0;x<W;x+=4){
      const i=(y*W+x)*4;
      if((.3*col[i]+.59*col[i+1]+.11*col[i+2])/255>=.07) bright++;
    }
    const density=(bright*16)/(W*H)||.25;
    let step=Math.max(1,Math.round(Math.sqrt((W*H*density)/TARGET)));
    const mirror=!lowEnd && (W*H*density)/(step*step) < TARGET*.62;
    for(let y=0;y<H;y+=step)for(let x=0;x<W;x+=step){
      const i=(y*W+x)*4, r=col[i]/255,g=col[i+1]/255,b=col[i+2]/255;
      const lum=.3*r+.59*g+.11*b;
      if(lum<.07) continue;
      const d=dep[i]/255;
      const z=(d*220 + lum*40) - 90;
      pos.push(x-W/2, -(y-H/2), z);
      // push toward the source's cold violet-cyan
      const cr=Math.min(1,r*1.05+.02), cg=Math.min(1,g*1.0), cb=Math.min(1,b*1.15+.05);
      cols.push(cr,cg,cb);
      rnd.push(Math.random());
      // a dimmer mirrored shell behind, so a full turn has volume instead of going paper-thin
      if(mirror && (x+y)%2===0){
        pos.push(x-W/2, -(y-H/2), -z*.72-18);
        cols.push(cr*.5,cg*.5,cb*.62);
        rnd.push(Math.random());
      }
    }
    const geo=new THREE.BufferGeometry();
    geo.setAttribute('position',new THREE.Float32BufferAttribute(pos,3));
    geo.setAttribute('color',new THREE.Float32BufferAttribute(cols,3));
    geo.setAttribute('rnd',new THREE.Float32BufferAttribute(rnd,1));
    const mat=new THREE.ShaderMaterial({
      transparent:true, depthWrite:false, blending:THREE.AdditiveBlending,
      uniforms:{uTime:{value:0},uMouse:{value:new THREE.Vector3(9999,9999,0)},uSize:{value:(1.35+step*.55)*renderer.getPixelRatio()},uPush:{value:0}},
      vertexShader:`
        attribute vec3 color; attribute float rnd;
        uniform float uTime,uSize,uPush; uniform vec3 uMouse;
        varying vec3 vC; varying float vA;
        void main(){
          vec3 p=position;
          p.x+=sin(uTime*.6+rnd*6.28)*.35; p.y+=cos(uTime*.5+rnd*6.28)*.35;
          vec2 dv=p.xy-uMouse.xy; float dist=length(dv);
          float f=smoothstep(90.,0.,dist)*uPush;
          p.xy+=normalize(dv+.0001)*f*38.; p.z+=f*(60.+rnd*120.);
          vec4 mv=modelViewMatrix*vec4(p,1.);
          gl_PointSize=uSize*(1000./-mv.z)*(1.+f*1.4);
          gl_Position=projectionMatrix*mv;
          float lum=dot(color,vec3(.3,.59,.11));
          vC=pow(color,vec3(.82))*1.3*(1.+f*.8);
          vA=clamp(.28+lum*1.7,0.,1.);
        }`,
      fragmentShader:`
        varying vec3 vC; varying float vA;
        void main(){ vec2 c=gl_PointCoord-.5; float d=length(c); if(d>.5) discard;
          gl_FragColor=vec4(vC,vA*smoothstep(.5,.1,d)); }`
    });
    const pts=new THREE.Points(geo,mat); group.add(pts);
    WWDIAG.add('points='+(pos.length/3)+' step='+step+' mirror='+mirror);

    /* phone tilt: the crucifix turns with the device */
    const tilt={on:false,x:0,y:0,base:null};
    const isTouch=matchMedia('(hover: none) and (pointer: coarse)').matches;
    function onOrient(e){
      if(e.beta==null&&e.gamma==null) return;
      let b=e.beta||0, g=e.gamma||0;
      const flip=(screen.orientation&&screen.orientation.angle)||0;
      if(flip===90){const t=b;b=-g;g=t}else if(flip===270){const t=b;b=g;g=-t}
      if(!tilt.base) tilt.base={b:b,g:g};
      const db=Math.max(-40,Math.min(40,b-tilt.base.b));
      const dg=Math.max(-40,Math.min(40,g-tilt.base.g));
      tilt.x=dg/40; tilt.y=-db/40; tilt.on=true;
    }
    function startTilt(){ addEventListener('deviceorientation',onOrient) }
    const btn=document.getElementById('tiltBtn');
    if(isTouch&&typeof DeviceOrientationEvent!=='undefined'){
      const needsPermission=typeof DeviceOrientationEvent.requestPermission==='function';
      if(needsPermission){
        if(btn){
          btn.hidden=false;
          btn.addEventListener('click',()=>{
            DeviceOrientationEvent.requestPermission().then(r=>{if(r==='granted')startTilt()}).catch(()=>{}).then(()=>{btn.hidden=true});
          });
        }
      } else { startTilt() }
    }
    addEventListener('orientationchange',()=>{tilt.base=null});

    let fit=1;
    function resize(){
      const w=sec.clientWidth,h=sec.clientHeight;
      renderer.setSize(w,h,false); camera.aspect=w/h; camera.updateProjectionMatrix();
      const visH=2*Math.tan(THREE.MathUtils.degToRad(17.5))*1000;
      const tall=camera.aspect<.75;
      fit=Math.min((visH*(tall?.74:.76))/H,(visH*camera.aspect*(tall?.98:.86))/W);
      group.scale.setScalar(fit); group.position.y=-visH*(tall?.12:.13);
    }
    resize(); addEventListener('resize',resize);

    // a full turn as you scroll, eased so it lingers face-on and sweeps through the profile
    const spinFromScroll=()=>{ const a=scrollTurn*6.2832; return a-0.35*Math.sin(2*a) };
    const target={x:0,y:0}, cur={x:0,y:0}; let push=0, pushT=0, lastMove=0;
    const drag={x:0,y:0}, vel={x:0,y:0}; let down=false, lx=0, ly=0, scrollTurn=0;
    const ray=new THREE.Raycaster(), ndc=new THREE.Vector2(), plane=new THREE.Plane(new THREE.Vector3(0,0,1),0), hit=new THREE.Vector3();
    function onMove(cx,cy){
      const r=canvas.getBoundingClientRect();
      const nx=(cx-r.left)/r.width*2-1, ny=-((cy-r.top)/r.height*2-1);
      target.x=nx; target.y=ny; ndc.set(nx,ny); pushT=1; lastMove=performance.now();
      ray.setFromCamera(ndc,camera);
      if(ray.ray.intersectPlane(plane,hit)){ const l=group.worldToLocal(hit.clone()); mat.uniforms.uMouse.value.set(l.x,l.y,0); }
    }
    canvas.addEventListener('pointermove',e=>{
      if(down){
        vel.x+=(e.clientX-lx)/innerWidth*1.35; vel.y+=(e.clientY-ly)/innerHeight*.9;
        lx=e.clientX; ly=e.clientY;
      }
      onMove(e.clientX,e.clientY);
    });
    canvas.addEventListener('pointerdown',e=>{down=true;lx=e.clientX;ly=e.clientY;vel.x=0;vel.y=0;onMove(e.clientX,e.clientY)});
    const release=()=>{down=false};
    canvas.addEventListener('pointerup',release);
    canvas.addEventListener('pointercancel',release);
    canvas.addEventListener('pointerleave',()=>{release();pushT=0;target.x=0;target.y=0});
    // scrolling the page turns it too, so it moves even if nobody touches it
    let ticking=false;
    addEventListener('scroll',()=>{
      if(ticking) return; ticking=true;
      requestAnimationFrame(()=>{ scrollTurn=Math.max(0,Math.min(1,(scrollY||0)/Math.max(1,innerHeight))); ticking=false });
    },{passive:true});

    let visible=true;
    new IntersectionObserver(es=>{visible=es[0].isIntersecting}).observe(sec);
    let looping=true;document.addEventListener('visibilitychange',()=>{if(!document.hidden&&!looping){looping=true;requestAnimationFrame(frame)}});
    const t0=performance.now();
    function frame(now){
      if(document.hidden){looping=false;return}
      requestAnimationFrame(frame);
      if(!visible) return;
      const t=(now-t0)/1000;
      if(now-lastMove>2500) pushT=0;
      const idle=reduce?0:Math.sin(t*.25)*.12;
      drag.x+=vel.x; drag.y+=vel.y;
      drag.x=Math.max(-1.3,Math.min(1.3,drag.x)); drag.y=Math.max(-.5,Math.min(.5,drag.y));
      if(!down){ vel.x*=.92; vel.y*=.92; drag.x*=.985; drag.y*=.97 }else{ vel.x*=.5; vel.y*=.5 }
      const tgX=(tilt.on?tilt.x:target.x)+drag.x+(isTouch?spinFromScroll():0), tgY=(tilt.on?tilt.y:target.y)+drag.y;
      const ease=isTouch?.07:.12;
      cur.x+=(tgX-cur.x)*ease; cur.y+=(tgY-cur.y)*ease;
      push+=(pushT-push)*.08;
      const gain=isTouch?.85:1.25;
      group.rotation.y=cur.x*(tilt.on?.85:gain)+(tilt.on?0:idle);
      group.rotation.x=-cur.y*(tilt.on?.4:(isTouch?.25:.45));
      mat.uniforms.uTime.value=reduce?0:t; mat.uniforms.uPush.value=push;
      renderer.render(scene,camera);
    }
    requestAnimationFrame(frame);
    setTimeout(()=>{ if(pos.length>3 && fb) fb.classList.add('gone') },350);
  }).catch(e=>fail(e&&e.message?e.message:'image load failed'));
}
const _boot=()=>('requestIdleCallback' in window)?requestIdleCallback(bootCrucifix,{timeout:1200}):setTimeout(bootCrucifix,200);
if(document.readyState==='complete')_boot();else addEventListener('load',_boot,{once:true});
